import React, { useState } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';
import AdvancedSearchUtility from '../../../../../../utility/AdvancedSearchUtility';
import FacetType from '../../../../../../utility/types/facetType';

function FilterModalPatternC({
  facetType,
  facetClass,
  facets,
  setFacets,
  addFacet,
  removeFacet,
  clearFacets,
}) {
  const valueSelectOptions = facetClass.getValueSelectOptions();
  const [selectedOperator, setSelectedOperator] = useState(facetType.validOperators[0]);
  const [selectedValueOptions, setSelectedValueOptions] = useState([]);

  const handleSelectOperatorOnChange = (e) => {
    const { value } = e.target;
    setSelectedOperator(value);
    if (facets.length > 0) {
      const updatedOperatorTypeFacets = facets
        .map((facet) => ({ ...facet, operatorId: Number(value) }));
      setFacets(updatedOperatorTypeFacets);
    }
  };

  const handleAddFacetValue = (newValue) => {
    if (facetType.id === FacetType.CHANNEL_TYPE) {
      const facetsToAdd = [];
      newValue.forEach((val) => {
        const newFacet = {
          facetId: facetType.id,
          operatorId: Number(selectedOperator),
          value1: val.toString(),
          value2: '',
        };
        facetsToAdd.push(newFacet);
      });
      setFacets([...facets, ...facetsToAdd]);
    } else {
      const newFacet = {
        facetId: facetType.id,
        operatorId: Number(selectedOperator),
        value1: newValue.toString(),
        value2: '',
      };
      addFacet(newFacet);
    }
  };

  const handleSelectValueOnChange = (values, action) => {
    if (action.action === 'select-option') {
      handleAddFacetValue(
        values.length > 0
          ? values[values.length - 1].value
          : '',
      );
    }
    /* istanbul ignore next */
    if (action.action === 'remove-value') {
      const channelTypeValuesToRemove = action.removedValue.value;
      if (facetType.id === FacetType.CHANNEL_TYPE) {
        const updatedFacets = facets
          .filter((facet) => !channelTypeValuesToRemove.includes(facet.value1));
        setFacets(updatedFacets);
      } else {
        const facetToRemoveIndex = facets
          .findIndex((facet) => facet.value1 === action.removedValue.value);
        removeFacet(facetToRemoveIndex);
      }
    }

    if (action.action === 'clear') {
      clearFacets();
    }
  };

  React.useLayoutEffect(() => {
    if (facets.length > 0) {
      setSelectedOperator(facets[0].operatorId);
      if (facetType.id === FacetType.CHANNEL_TYPE) {
        setSelectedValueOptions(
          valueSelectOptions
            .filter((option) => facets.some((facet) => option.value.includes(facet.value1))),
        );
      } else if (facetType.id === FacetType.ALERT_NOTIFICATION_TEMPLATES) {
        // ALERT_NOTIFICATION_TEMPLATES stores value1 as string,
        // but options use numeric IDs — normalize locally for react-select

        setSelectedValueOptions(
          AdvancedSearchUtility.getSelectedOptionsByValue(
            valueSelectOptions.map((option) => ({
              ...option,
              value: option.value.toString(),
            })),
            facets,
            'value1',
          ),
        );
      } else {
        setSelectedValueOptions(AdvancedSearchUtility.getSelectedOptionsByValue(
          valueSelectOptions,
          facets,
          'value1',
        ));
      }
    }
  }, []);

  /* istanbul ignore next */
  return (
    <div>
      <h6>
        {`${facetClass.getDisplayName()} ${facetClass.getDescription()}`}
      </h6>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <select
              className="form-control"
              data-testid="operator-combobox"
              onChange={handleSelectOperatorOnChange}
              value={selectedOperator}
            >
              {
                facetClass.getOperatorSelectOptions().map((option) => (
                  <option key={option.label} value={option.value}>
                    {option.label}
                  </option>
                ))
              }
            </select>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <form data-testid="form">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="sr-only" htmlFor="facetValue">Facet Value</label>
              <Select
                name="facetValue"
                inputId="facetValue"
                isMulti
                isClearable={false}
                onChange={handleSelectValueOnChange}
                options={valueSelectOptions}
                value={selectedValueOptions}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
FilterModalPatternC.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number,
    validOperators: PropTypes.arrayOf(PropTypes.number),
    displayValue: PropTypes.string,
    modalType: PropTypes.number,
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape(searchFilterPropType)).isRequired,
  setFacets: PropTypes.func.isRequired,
  addFacet: PropTypes.func.isRequired,
  removeFacet: PropTypes.func.isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
  clearFacets: PropTypes.func.isRequired,
};
export default FilterModalPatternC;
